import { useContext } from "react";
import { PrefetchHooksContext } from "../../internal/prefetching/PrefetchHooksContext";
export default function usePrefetchQueries() {
    return useContext(PrefetchHooksContext);
}

//# sourceMappingURL=usePrefetchQueries.js.map